import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../../../global/button/Button'
import { BasicModal } from '../BasicModal'
import { ConfirmModalProps } from './ConfirmModal'

export const ConfirmModalDesktop: React.FC<PropsWithChildren<ConfirmModalProps>> = (props) => {
  const { t } = useTranslation()

  const { size, title, isValid, children } = props
  const { renderFooter, onConfirm, onClose } = props

  return (
    <BasicModal
      title={title}
      size={size}
      renderFooter={({ onClose }) =>
        renderFooter?.({ ...props, onClose }) || [
          <Button.New appearance='secondary' onClick={onClose}>
            {t('Cancel')}
          </Button.New>,
          <Button.New appearance='primary' disabled={!isValid} onClick={onConfirm}>
            {t('Confirm')}
          </Button.New>,
        ]
      }
      onClose={onClose}
    >
      {children}
    </BasicModal>
  )
}
